/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Schema$UserPickUserInfo } from '@interface/user-pick'
import { BadgeStyle } from '@styles/base.style'
import { Badge } from 'antd-mobile'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import AdvImg from '@components/AdvImg'

export interface UserPickProfileProps {
  userInfo: Schema$UserPickUserInfo
  showNick?: boolean
  showMatchCount?: boolean
  showBg?: boolean
  showBadge?: boolean
  showSMark?: boolean
  userTitleEnabled?: boolean
}

export const UserPickProfile: React.FC<UserPickProfileProps> = observer((props): React.ReactElement => {
  const {
    userInfo,
    showNick = false,
    showBg = false,
    showBadge = false,
    showMatchCount = false,
    showSMark = false,
    userTitleEnabled = userInfo.userTitleEnabled,
  } = props

  const userBlocked = userInfo?.isBlocked || false

  return (
    <Fragment>
      <div
        className={(userInfo.isCustomProfileImg || userInfo.userNick === '전체') ? 'profile is-profile-custom' : 'profile'}>
        {showBg && <span className="bg"/>}
        <div className={userBlocked ? 'profile-img-wrap blocked lhn31' : 'profile-img-wrap lhn31'}>
          {userInfo.isCustomProfileImg ?
            (<AdvImg src={userInfo.userProfileImg} srcMode={'small'} alt="사진첩 프로필" className="profile-img custom-img" loading="lazy"/>)
            :
            (<AdvImg src={userInfo.userProfileImg} srcMode={'small'} alt="스킨 프로필" className="profile-img" loading="lazy"/>)
          }
        </div>
        {showBadge && <Badge text={userInfo.matchCount} overflowCount={99} css={BadgeStyle}/>}
        <UserPickSpecialMemberMark
          showSMark={showSMark}
          isSpecialMember={userInfo.isSpecialMember}
          userTitleId={userInfo.userTitleId}
          userTitleEnabled={userTitleEnabled}
          darkBorder
        />
      </div>
      {showNick && <span className="name">{userInfo.userNick}</span>}
      {showMatchCount && <span className="count">{userInfo.matchCount}</span>}
    </Fragment>
  )
})
